import React from "react";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';

import { Session, SessionPreview } from "../../../../types/working-model";
import Icon, { ICONS, COLORS } from "../../../general-ui/icon";
import { OptionalComponent } from "../../../../utils/optional-component";

import "react-datepicker/dist/react-datepicker.css";
import './reorder-sessions-modal.scss';

interface ISortableContentItemProps {
	id: string;
	session: Session | SessionPreview;
	disableSessionThumbnails: boolean | undefined;
	defaultImage: string;
}

const SortableItem: React.FC<ISortableContentItemProps> = ({ id, session, disableSessionThumbnails, defaultImage }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({ id: id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<li className='reorder-row' ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<div className="drag-handle" {...attributes} {...listeners}>
				<Icon name={ICONS.DRAG_HANDLE} size={14} color={COLORS.GRAY} />
			</div>
			<div className="content-details">
				<OptionalComponent display={!disableSessionThumbnails}>
					{session.image ?
						<img src={session.image} alt={"session image"} /> : <img src={defaultImage} alt={"session image"} />}
				</OptionalComponent>

				<div className="content-description">
					<div className="content-type">{session?.session_type}</div>
					<div className="content-title">{session?.title.base}</div>
				</div>
			</div>
		</li>
	);
};


export default SortableItem;